import { NgModule } from '@angular/core';
import { Routes, RouterModule, PreloadAllModules } from '@angular/router';
import { LayoutComponent } from './layout/layout.component';
import { HomeComponent } from './layout/home/home.component';
import { PageNotFoundComponent } from './shared/components/page-not-found/page-not-found.component';
import { AuthGuard } from './core/guards/auth.guard';
import { ProfileGuard } from './core/guards/profile.guard';
import { MainLayoutComponent } from './layout/main-layout/main-layout.component';

const routes: Routes = [
  // Redirects (must come before the '' route, otherwise the empty-path
  // route + its '**' wildcard child will swallow '/login' before this
  // redirect is ever evaluated)

  {
    path: 'login',
    pathMatch: 'full',
    redirectTo: '/auth/login',
  },

  // Auth

  {
    path: 'auth',
    loadChildren: () =>
      import('./features/auth/auth.module').then((m) => m.AuthModule),
  },

  // Main Layout

  {
    path: '',
    component: MainLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        component: HomeComponent,
        canActivate: [ProfileGuard],
        pathMatch: 'full',
        data: { titleKey: 'HomePage' },
      },
      {
        path: 'profile',
        loadChildren: () =>
          import('./features/profile/profile.module').then(
            (m) => m.ProfileModule,
          ),
      },
      {
        path: 'workshops',
        canActivate: [ProfileGuard],
        loadChildren: () =>
          import('./features/workshop/workshop.module').then(
            (m) => m.WorkshopModule,
          ),
      },
      {
        path: 'held-workshops',
        canActivate: [ProfileGuard],
        loadChildren: () =>
          import('./features/held-workshop/held-workshop.module').then(
            (m) => m.HeldWorkshopModule,
          ),
      },
      {
        path: 'e-workshops',
        canActivate: [ProfileGuard],
        loadChildren: () =>
          import('./features/e-workshop/e-workshop.module').then(
            (m) => m.EWorkshopModule,
          ),
      },
      {
        path: 'feedback',
        canActivate: [ProfileGuard],
        loadChildren: () =>
          import('./features/feedback/feedback.module').then(
            (m) => m.FeedbackModule,
          ),
      },
      {
        path: 'message',
        canActivate: [ProfileGuard],
        loadChildren: () =>
          import('./features/message/message.module').then(
            (m) => m.MessageModule,
          ),
      },
      {
        path: 'teachers/:id',
        canActivate: [ProfileGuard],
        loadComponent: () =>
          import('./features/teacher-profile/components/teacher-profile/teacher-profile.component').then(
            (m) => m.TeacherProfileComponent,
          ),
      },
      {
        path: '**',
        component: PageNotFoundComponent,
      },
    ],
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      preloadingStrategy: PreloadAllModules,
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
